import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';
@Injectable()
export class AutoPlanService {

    constructor(private httpClient: HttpClient) {
    }

    getPlanesByDocument(documentType, documentNumber) {
        const _urlParams = `documentType=${documentType}&documentNumber=${documentNumber}`;
        return this.httpClient.get(environment.server.api.portalpas + '/Policy/plans?' + _urlParams).pipe(
            map(mapResponseWithData));
    }
}
